module.exports = __webpack_public_path__ + "static/media/police.5b96b7df.svg";